import { Route, Routes } from 'react-router-dom';

import About from '@pages/About';
import CompanyAccountCreatePage from '@pages/account/CompanyAccountCreatePage';
import CompanyAccountListPage from '@pages/account/CompanyAccountListPage';
import FreeAccountCreatePage from '@pages/account/FreeAccountCreatePage';
import FreeAccountListPage from '@pages/account/FreeAccountListPage';
import Home from '@pages/Home';
import LoginPage from '@pages/auth/LoginPage';
import PrivateRoute from "./PrivateRoute";
import LogoutPage from '@pages/auth/LogoutPage';
import Main from '@pages/main/Main';
import NotFound from '@pages/NotFound';
import PlannedProjectCreatePage from '@pages/project/PlannedProjectCreatePage';
import PlannedProjectListPage from '@pages/project/PlannedProjectListPage';
import ProfileCreatePage from '@pages/profile/ProfileCreatePage';
import ProfileDetailPage from '@pages/profile/[id]/ProfileDetailPage';
import ProfileListPage from '@pages/profile/ProfileListPage';
import React from 'react';
import SalesPurchaseManagementPage from '@pages/project/SalesPurchaseManagementPage';
import SelfAccountCreatePage from '@pages/account/SelfAccountCreatePage';
import SelfAccountListPage from '@pages/account/SelfAccountListPage';
import UserListPage from '@pages/setting/UserListPage';
import ProjectListPageV2 from '@pages/project/ProjectListPageV2';
import ProjectCreatePageV2 from '@pages/project/ProjectCreatePageV2';

const AppRoutes = () => {
  return (
    <Routes>
      {/* 로그인화면 */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/logout" element={<LogoutPage />} />

      {/* 메인화면 */}
      {/* 사업관리 화면 */}
      <Route path="/project" element={<Main />}>
        {/* <Route path="projectListOld" element={<ProjectListPage />} /> 사업현황 목록 (V1) */}
        {/* <Route path="projectCreateOld" element={<ProjectCreatePage />} /> 사업현황 등록 (V1) */}
        <Route path="projectList" element={<ProjectListPageV2 />} /> {/* 사업현황 목록 (V2) */}
        <Route path="projectCreate" element={<ProjectCreatePageV2 />} /> {/* 사업현황 등록 (V2) */}
        <Route path="plannedProjectList" element={<PlannedProjectListPage />} /> {/* 예정사업 목록 */}
        <Route path="plannedProjectCreate" element={<PlannedProjectCreatePage />} /> {/* 예정사업 등록 */}
        <Route path="salesPurchaseManagement" element={<SalesPurchaseManagementPage />} /> {/* 매출매입관리 목록 */}
      </Route>
      {/* 거래처관리 화면 */}
      <Route path="/account" element={<Main />}>
        <Route path="companyAccountList" element={<CompanyAccountListPage />} /> {/* 법인사업자 목록 */}
        <Route path="companyAccountCreate" element={<CompanyAccountCreatePage />} /> {/* 법인사업자 등록 */}
        <Route path="selfAccountList" element={<SelfAccountListPage />} /> {/* 개인사업자 목록 */}
        <Route path="selfAccountCreate" element={<SelfAccountCreatePage />} /> {/* 개인사업자 등록 */}
        <Route path="freeAccountList" element={<FreeAccountListPage />} /> {/* 프리랜서 목록 */}
        <Route path="freeAccountCreate" element={<FreeAccountCreatePage />} /> {/* 프리랜서 등록 */}
      </Route>
      {/* 프로필관리 화면 */}
      <Route path="/profile" element={<Main />}>
        <Route path="list" element={<ProfileListPage />} />
        <Route path="create" element={<ProfileCreatePage />} />
        <Route path="detail/:id" element={<ProfileDetailPage />} />
      </Route>
      {/* 설정 화면 */}
      <Route element={<PrivateRoute />}>
        <Route path="/setting" element={<Main />}>
          <Route path="userList" element={<UserListPage />} /> {/* 사용자관리 목록 */}
        </Route>
      </Route>

      {/* 샘플화면 */}
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
